import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useMenuNavigationStyles = (theme: Theme) => {
  const isDarkTheme = theme.palette.mode === 'dark';

  return {
    root: css({
      color: isDarkTheme ? theme.palette.info.contrastText : theme.palette.grey.A700,
      padding: theme.spacing(0, 5),
    }),
  };
};
